import { css as e, styled as t } from "styled-components";
//#region src/components/TimePicker/styled/TimePanel.styled.ts
var n = t.div`
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 200;
    background: ${({ theme: e }) => e.colors.card};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    box-shadow: ${({ theme: e }) => e.shadows.lg};
    padding: ${({ theme: e }) => e.spacing(2)};
    animation: tpIn 0.12s ease;
    @keyframes tpIn {
        from {
            opacity: 0;
            transform: translateY(-4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`, r = t.div`
    padding: ${({ theme: e }) => e.spacing(2)};
`, i = t.div`
    display: flex;
    gap: ${({ theme: e }) => e.spacing(1)};
`, a = t.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(.5)};
    min-width: 56px;
`, o = t.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 196px;
    overflow-y: auto;
    padding-right: 2px;

    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({ theme: e }) => e.colors.border};
        border-radius: 2px;
    }
`, s = t.button`
    border: none;
    background: ${({ theme: e, $sel: t }) => t ? e.colors.primary : "transparent"};
    color: ${({ theme: e, $sel: t }) => t ? e.colors.primaryForeground : e.colors.foreground};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e, $sel: t }) => t ? e.typographyTokens.weights.semibold : e.typographyTokens.weights.normal};
    padding: ${({ theme: e }) => e.spacing(.75, 1.5)};
    border-radius: ${({ theme: e }) => e.radii.md};
    cursor: pointer;
    text-align: center;
    transition:
        background ${({ theme: e }) => e.transitions.fast},
        color ${({ theme: e }) => e.transitions.fast};

    ${({ $sel: t, theme: n }) => !t && e`
            &:hover {
                background: ${n.colors.accent};
            }
        `}
`;
//#endregion
export { s as Cell, a as Column, i as Columns, r as MobileContent, n as Popover, o as ScrollList };
